module.exports = __webpack_public_path__ + "img/analytics.bfe1b16a.svg";